import { ChangeAward } from './ChangeAward';

export class ChangeAwardImage extends ChangeAward {
  type: string = 'Award.ChangeImageUrl';
}
